export default __webpack_public_path__ + "static/media/homeLight.76d72dc9.svg";